// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"HintPopup_titleWrapper__3KGKp","textWrapper":"HintPopup_textWrapper__2nZX_","modalWrapper":"HintPopup_modalWrapper__3Jv_F"};